<template>
  <div class="mb-2" style="margin-bottom:10px;margin-top:10px">
    <a-alert type="error" :message="message" banner closable/>
  </div>
</template>

<script>
export default {
  props: {
    message: Array
  }
};
</script>
